<template>
  <div style="max-width:600px">
    <b-form ref="recordForm" id="recordForm">
      <div>
        <b-checkbox
          size="sm"
          id="checkbox-kgr-active"
          name="checkbox-kgr-active"
          value="true"
          unchecked-value="false"
          v-model="editRecord.settings['KGR_Selections_Active']"
          @change="isDirty = true"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        >
          <span class="text-muted ">Kostengruppen</span>
        </b-checkbox>
      </div>

      <b-form-radio-group
        style="margin-left:21px"
        v-show="editRecord.settings['KGR_Selections_Active'] == 'true'"
        v-model="editRecord.settings['KGR_Mode']"
        id="radio-group-1"
        size="sm"
        :options="[
          { text: 'Freitext', value: 'F' },
          { text: 'Selektionsauswahl', value: 'S' }
        ]"
        name="radio-options"
        class="text-muted"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <b-checkbox
          class="custom-control-inline"
          size="sm"
          id="checkbox-kgr-print"
          name="checkbox-kgr-print"
          value="true"
          unchecked-value="false"
          v-model="editRecord.settings['KGR_Print']"
          @change="isDirty = true"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        >
          <span class="text-muted ">Auf Rechnungsbegleitblatt anzeigen</span>
        </b-checkbox>
      </b-form-radio-group>

      <b-form-textarea
        style="margin-left:21px"
        v-show="editRecord.settings['KGR_Selections_Active'] == 'true' && editRecord.settings['KGR_Mode'] == 'S'"
        id="textarea"
        v-model="editRecord.settings['KGR_Selections']"
        placeholder="Ein Eintrag pro Zeile..."
        rows="5"
        max-rows="5"
        @change="isDirty = true"
        @input="$refs['KGR_Selections'].setCustomValidity('')"
        ref="KGR_Selections"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      ></b-form-textarea>
      <b-checkbox
        size="sm"
        id="checkbox-responsible-active"
        name="checkbox-responsible-active"
        value="true"
        unchecked-value="false"
        v-model="editRecord.settings['Responsible_Selections_Active']"
        class="mt-3"
        @change="isDirty = true"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <span class="text-muted">Verantwortlich</span>
      </b-checkbox>
      <b-form-radio-group
        style="margin-left:21px"
        v-show="editRecord.settings['Responsible_Selections_Active'] == 'true'"
        v-model="editRecord.settings['Responsible_Mode']"
        id="radio-group-2"
        size="sm"
        :options="[
          { text: 'Freitext', value: 'F' },
          { text: 'Selektionsauswahl', value: 'S' }
        ]"
        name="radio-options-2"
        class="text-muted"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <b-checkbox
          class="custom-control-inline"
          size="sm"
          id="checkbox-responsible-print"
          name="checkbox-responsible-print"
          value="true"
          unchecked-value="false"
          v-model="editRecord.settings['Responsible_Print']"
          @change="isDirty = true"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        >
          <span class="text-muted ">Auf Rechnungsbegleitblatt anzeigen</span>
        </b-checkbox>
      </b-form-radio-group>
      <b-form-textarea
        style="margin-left:21px"
        v-show="
          editRecord.settings['Responsible_Selections_Active'] == 'true' &&
            editRecord.settings['Responsible_Mode'] == 'S'
        "
        id="textarea"
        v-model="editRecord.settings['Responsible_Selections']"
        placeholder="Ein Eintrag pro Zeile..."
        rows="5"
        max-rows="5"
        @change="isDirty = true"
        ref="Responsible_Selections"
        @input="$refs['Responsible_Selections'].setCustomValidity('')"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      ></b-form-textarea>
      <b-checkbox
        size="sm"
        id="checkbox-fa1-active"
        name="checkbox-fa1-active"
        value="true"
        unchecked-value="false"
        v-model="editRecord.settings['FA1_Active']"
        class="mt-3"
        @change="isDirty = true"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <span class="text-muted">Freies Attribut 1</span>
      </b-checkbox>
      <label v-show="editRecord.settings['FA1_Active'] == 'true'" style="margin-left:22px;" class="text-muted mb-1">
        <small>Feldbezeichnung</small>
      </label>
      <b-input
        v-show="editRecord.settings['FA1_Active'] == 'true'"
        style="margin-left:22px"
        v-model.lazy="editRecord.settings['FA1']"
        @change="isDirty = true"
        class="mb-2"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      />
      <b-form-radio-group
        style="margin-left:22px"
        v-show="editRecord.settings['FA1_Active'] == 'true'"
        v-model="editRecord.settings['FA1_Mode']"
        id="radio-group-3"
        size="sm"
        :options="[
          { text: 'Freitext', value: 'F' },
          { text: 'Selektionsauswahl', value: 'S' }
        ]"
        name="radio-options-3"
        class="text-muted"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <b-checkbox
          class="custom-control-inline"
          size="sm"
          id="checkbox-fa1-print"
          name="checkbox-fa1-print"
          value="true"
          unchecked-value="false"
          v-model="editRecord.settings['FA1_Print']"
          @change="isDirty = true"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        >
          <span class="text-muted ">Auf Rechnungsbegleitblatt anzeigen</span>
        </b-checkbox>
      </b-form-radio-group>

      <b-form-textarea
        v-show="editRecord.settings['FA1_Active'] == 'true' && editRecord.settings['FA1_Mode'] == 'S'"
        style="margin-left:22px"
        id="textarea"
        v-model="editRecord.settings['FA1_Selections']"
        placeholder="Ein Eintrag pro Zeile..."
        rows="5"
        max-rows="5"
        @change="isDirty = true"
        ref="FA1_Selections"
        @input="$refs['FA1_Selections'].setCustomValidity('')"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      ></b-form-textarea>

      <b-checkbox
        size="sm"
        id="checkbox-fa2-active"
        name="checkbox-fa2-active"
        value="true"
        unchecked-value="false"
        v-model="editRecord.settings['FA2_Active']"
        class="mt-3"
        @change="isDirty = true"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <span class="text-muted">Freies Attribut 2</span>
      </b-checkbox>
      <label v-show="editRecord.settings['FA2_Active'] == 'true'" style="margin-left:22px;" class="text-muted mb-1">
        <small>Feldbezeichnung</small>
      </label>
      <b-input
        v-show="editRecord.settings['FA2_Active'] == 'true'"
        style="margin-left:22px"
        v-model.lazy="editRecord.settings['FA2']"
        @change="isDirty = true"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        class="mb-2"
      />
      <b-form-radio-group
        style="margin-left:22px"
        v-show="editRecord.settings['FA2_Active'] == 'true'"
        v-model="editRecord.settings['FA2_Mode']"
        id="radio-group-5"
        size="sm"
        :options="[
          { text: 'Freitext', value: 'F' },
          { text: 'Selektionsauswahl', value: 'S' }
        ]"
        name="radio-options-5"
        class="text-muted"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      >
        <b-checkbox
          class="custom-control-inline"
          size="sm"
          id="checkbox-fa2-print"
          name="checkbox-fa2-print"
          value="true"
          unchecked-value="false"
          v-model="editRecord.settings['FA2_Print']"
          @change="isDirty = true"
          :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
        >
          <span class="text-muted ">Auf Rechnungsbegleitblatt anzeigen</span>
        </b-checkbox>
      </b-form-radio-group>

      <b-form-textarea
        v-show="editRecord.settings['FA2_Active'] == 'true' && editRecord.settings['FA2_Mode'] == 'S'"
        style="margin-left:22px"
        id="textarea"
        v-model="editRecord.settings['FA2_Selections']"
        placeholder="Ein Eintrag pro Zeile..."
        rows="5"
        max-rows="5"
        @change="isDirty = true"
        ref="FA2_Selections"
        @input="$refs['FA2_Selections'].setCustomValidity('')"
        :disabled="!($root.$user.isPlaner || $root.$user.isAdmin)"
      ></b-form-textarea>

      <b-button class="mt-4" @click="updateSettings" v-if="$root.$user.isPlaner || $root.$user.isAdmin">
        Speichern
      </b-button>
    </b-form>
  </div>
</template>

<script>
import settingsStore from '@/store/Settings';
import projectService from '@/service/ProjectsService';
import AppState from '@/store/App.js';
export default {
  data() {
    return {
      settingsStore,
      editRecord: {
        settings: []
      },
      isDirty: false
    };
  },
  methods: {
    async checkMaxLengths(field) {
      const selection = this.editRecord.settings[field + '_Selections'].split('\n');
      const ref = this.$refs[field + '_Selections'];
      const resultItems = [];
      ref.setCustomValidity('');
      for (const item of selection) {
        if (item.length > 50) {
          resultItems.push(item.substring(0, 47) + '...');
          /*
          if (this.editRecord.settings[field + '_Selections_Active'] != 'true')
            this.editRecord.settings[field + '_Selections_Active'] = 'true';
          if (this.editRecord.settings[field + '_Mode'] != 'S') this.editRecord.settings[field + '_Mode'] = 'S';
          await this.$forceUpdate();
          ref.setCustomValidity('Einträge dürfen eine max. Länge von 50 Zeichen nicht überschreiten');
          this.$refs.recordForm.reportValidity();
          return true;
          */
        } else resultItems.push(item);
      }
      this.editRecord.settings[field + '_Selections'] = resultItems.join('\n');

      return false;
    },
    async updateSettings() {
      if (await this.checkMaxLengths('KGR')) return;
      if (await this.checkMaxLengths('Responsible')) return;
      if (await this.checkMaxLengths('FA1')) return;
      if (await this.checkMaxLengths('FA2')) return;
      settingsStore.settings = this.editRecord.settings;
      projectService.updateProjectSettings(settingsStore.settings).then(() => {
        this.$showSuccess(this, 'Einstellungen', 'Einstellungen erfolgreich aktualisiert.');
        this.isDirty = false;
      });
    }
  },
  activated() {
    this.editRecord.settings = { ...this.settingsStore.settings }; // create a copy of the settings, so if the user changes fields and leaves the page, original settings are not affected
    this.isDirty = false;
    AppState.isLoading = false;
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      // did the user change a field?
      const answer = window.confirm('Sie haben ungespeicherte Änderungen. Wollen Sie die Seite wirklich verlassen?');
      if (answer) {
        // Yes, user wants to leave page without saving
        next();
      } else {
        next(false); // No, user wants to stay. Let's abort the navigation.
      }
    } else next();
  }
};
</script>

<style>
/*
.custom-checkbox.b-custom-control-sm,
.input-group-sm .custom-checkbox,
.b-custom-control-sm {
  font-size: 80%;
  line-height: 1.5;
  padding-left: 1.3125rem;
}*/
.tooltip-text-left .tooltip-inner {
  text-align: left;
}
.b-custom-control-sm > label,
.b-custom-control-sm > label > span {
  font-size: 11.52px;
  padding-top: 2px;
}
</style>
